import { PageForm } from "../_form";

export default function NewPagePage() {
  return (
    <div>
      <h1 className="font-display text-2xl lg:text-3xl font-bold mb-1">Trang mới</h1>
      <p className="text-sm text-ink-muted mb-6">
        Tạo trang tĩnh — landing, giới thiệu, chính sách, hoặc bất kỳ nội dung không mang tính tin
        tức nào.
      </p>
      <PageForm mode="create" />
    </div>
  );
}
